export { lv } from '@payloadcms/translations/languages/lv'
